'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialChrome = function IoSocialChrome(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.3 20c0-2.9 2.3-5.2 5.2-5.2s5.2 2.3 5.2 5.2-2.3 5.2-5.2 5.2-5.2-2.3-5.2-5.2z m22.5-3c0.1 1 0.2 2 0.2 3 0 8.3-5.8 15.2-13.6 17-0.8 0.2-1.6 0.3-2.3 0.4-0.6 0.1-1.1 0.1-1.6 0.1-0.6 0-1.3 0-2-0.1v-0.1l8-13.8c0.6-1 1-2.2 1-3.5 0-2.1-1-3.9-2.5-5.2h12.2c0.3 0.7 0.4 1.5 0.6 2.2-0.2-0.7-0.3-1.5-0.6-2.2 0.3 0.7 0.4 1.5 0.6 2.2z m-17.3 10c0.8 0 1.6-0.2 2.3-0.4l-6.1 10.5c-3.3-0.7-6.2-2.3-8.5-4.6-3.2-3.2-5.2-7.6-5.2-12.5 0-2.4 0.5-4.8 1.4-6.9 0.6-1.2 1.3-2.4 2-3.5l8.1 13.9c1.2 2.1 3.3 3.5 6 3.5z m-12.9-18.8v-0.1c1.9-2 4.3-3.6 7-4.6 1.8-0.6 3.9-1 5.9-1 5.7 0 10.8 2.8 14 7h0.1c0.7 1.1 1.4 2.3 1.9 3.5-0.5-1.2-1.2-2.4-1.9-3.5h-0.1c0.8 1.1 1.5 2.3 2 3.5h-16c-3.4 0-6.2 2.5-6.8 5.6z' })
        )
    );
};

exports.default = IoSocialChrome;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-chrome.js
// module id = 2453
// module chunks = 0